<template>
  <div style="position: relative">
    <!-- 左侧图例 -->
    <div v-if="showCompany === 1 || zoomNow > 8" class="legend">
      <p class="legend_title">图例</p>
      <template v-for="item in showAll ? listOfOption : selectOptions">
        <div :key="item" class="legend_li">
          <p class="square" :style="{ backgroundColor: optionsLengend[item] }"></p>
          <p class="txt">{{ item }}</p>
        </div>
      </template>
    </div>
    <!-- 左侧区域汇总图例 -->
    <div v-if="showCompany === 3" class="legendProvince">
      <p class="legend_title">区域</p>
      <div class="legend_li" v-for="item in provinceArr" :key="item" @click="changeProvince(item)"
        :class="{ activeTab: item === activeProvince }">
        <p class="txt">{{ item }}</p>
      </div>
      <div class="legend_li_all" v-if="allProvinceDetail.length > 0">
        <!-- 只计算 苯供需的产能合计 -->
        产能合计：{{
          allProvinceDetail
            .filter((item) => item.varieties === "苯供需")
            .reduce((pre, cur) => pre + cur.sum, 0)
        }}
      </div>
    </div>
    <!-- 右侧选择 -->
    <div style="
        text-align: right;
        margin-right: 30px;
        position: absolute;
        z-index: 10;
        top: 20px;
        right: 20px;
        margin-bottom: 10px;
      ">
      <el-radio-group style="margin-right: 20px; margin-top: -2px" v-model="showCompany" size="small"
        @change="changeButton">
        <el-radio-button :label="1">企业产能</el-radio-button>
        <el-radio-button :label="2">区域汇总</el-radio-button>
        <el-radio-button :label="3">区域供需汇总</el-radio-button>
      </el-radio-group>
      <el-select v-model="selectTypes" multiple collapse-tags size="small" placeholder="请选择种类">
        <el-option v-for="item in listOfOption" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="changeSelect">确认</el-button>
    </div>
    <div class="echartLeft" style="margin-top: -24px">
      <div id="container" style="height: 500px"></div>
    </div>
    <div class="content">
      <div class="detail" v-show="detailLlag">
        <img @click="closeDio" src="../../../assets/images/confirm.png" alt="" />
        <p>{{ verneCompanyDetail.company_name }}</p>
        <div class="top">
          <span>国别</span>
          <em>{{
            verneCompanyDetail.country ? verneCompanyDetail.country : ""
          }}</em>
        </div>
        <div class="top" style="margin-top: 0">
          <span>地址</span>
          <em>{{ verneCompanyDetail.area_name }}</em>
        </div>
        <div class="top" style="margin-top: 0" v-for="item in verneCompanyDetail.varietie" :key="item.varieties">
          <template v-if="item.sum_capacity != 0">
            <span>{{ item.varieties }}</span>
            <em>{{ item.sum_capacity }}</em>
          </template>
        </div>
      </div>
    </div>
    <!-- 区域供需汇总右侧详细信息 -->
    <div class="content" v-show="showCompany === 3 && activeProvinceDetail.length > 0">
      <div class="detail">
        <p style="margin-bottom: 10px">{{ activeProvince }}</p>
        <div class="top" style="margin-top: 0" v-for="item in activeProvinceDetail" :key="item.varieties">
          <span>{{ item.varieties }}</span>
          <em>{{ item.sum }}</em>
        </div>
      </div>
    </div>

    <div class="detailDetail"></div>
    <!-- 半径输入弹框 -->
    <el-dialog title="设置距离" :visible.sync="radiusDialogVisible" width="30%" :close-on-click-modal="false"
      @close="resetRadius">
      <el-form label-width="80px">
        <el-form-item label="公司：">
          <div>{{ verneCompanyDetail.company_name }}</div>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item label="品种：">
              <el-select v-model="selectTypes" multiple collapse-tags size="small" placeholder="请选择种类">
                <el-option v-for="item in listOfOption" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="半径：">
              <el-input type="number" v-model.number="radius" placeholder="请输入距离" size="small"
                style="width: 200px; vertical-align: middle" min="0">
                <template slot="append">km</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="radiusDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmRadius" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import * as _ from "lodash";
import {
  oilBenzeneMapDetail,
  methanolMapSelect,
  companyDetailFangTing,
  areaDetailFangTing,
  mapBen,
} from "@/api/map";
import $ from "jquery";

export default {
  data() {
    return {
      mapM: null,
      mapCenter: null,
      markers: [], //所有点
      zoomNow: 5,
      districtExplorer: null, //保存DistrictExplorer实例
      // 区域名称到adcode数组的映射
      areaAdcodeMap: {
        华东地区: [340000, 330000, 320000, 310000], // 安徽、浙江、江苏、上海
        华北地区: [120000, 110000, 130000, 140000, 150000, 370000], // 天津、北京、河北、山西、内蒙、山东
        华南地区: [450000, 460000, 440000, 350000], // 广西、海南、广东、福建
        华中地区: [420000, 410000, 430000, 360000], // 湖北、河南、湖南、江西
        西南地区: [500000, 530000, 510000, 520000], // 重庆、云南、四川、贵州（移除了与西北重复的甘肃）
        西北地区: [620000, 650000, 640000, 630000, 610000], // 甘肃、新疆、宁夏、青海、陕西
        东北地区: [230000, 220000, 210000], // 黑龙江、吉林、辽宁
      },
      oneB: [
        {
          name: "北京市",
          center: "116.405285,39.904989",
          type: 0,
          subDistricts: [],
        },
      ],
      selectTypes: [],
      listOfOption: [],
      showCompany: 1,
      allCompnays: null,
      polylines: [],
      markertNow: [], //选中的红
      markertNowPOsition: null, // 选中的位置
      canShowDetailDetail: 1, //默认 不显示  0 显示
      //选中的某坐标
      onePosition: [],
      oneCompanyCode: "",
      varieties: "",
      companys: [],
      provinceCompanys: [],
      oneType: "",
      verneCompanyDetail: {},
      detailLlag: false,
      optionsLengend: {
        苯加氢: "rgb(250, 154, 6)",
        石油苯: "rgb(3, 182, 236)",
        苯乙烯: "rgb(244, 227, 14)",
        PS: "rgb(82, 55, 215)",
        EPS: "rgb(255, 133, 132)",
        ABS: "rgb(180, 189, 58)",
        己内酰胺: "rgb(194, 240, 205)",
        己二酸: "rgb(99, 108, 173)",
        苯酚: "rgb(33, 210, 111)",
        苯胺: "rgb(242, 76, 76)",
      },
      showAll: true,
      selectOptions: [],
      // 半径弹框相关
      radiusDialogVisible: false,
      radius: null,
      selectedPosition: null, // 新增：保存选中标记的位置
      circles: [], // 新增：保存已绘制的圆，方便清除
      highlightPolygons: [], // 新增：保存高亮的区域多边形
      provinceArr: [
        "华东地区",
        "华北地区",
        "华南地区",
        "华中地区",
        "西南地区",
        "西北地区",
        "东北地区",
      ],
      activeProvince: "",
      activeProvinceDetail: [],
      allProvinceDetail: [],
    };
  },
  created() {
    this.getDistinctVarieties();
  },
  mounted() {
    let dHeight = $(window).height() - 170;
    $("#container").height(dHeight + "px");
    this.mapCenter = new AMap.LngLat(116.397428, 39.90923);
    this.mapM = new AMap.Map("container", {
      zoom: this.zoomNow,
    });
    // 地图控件
    // AMap.plugin(['AMap.ToolBar'], () => {
    //   this.mapM.addControl(new AMap.ToolBar({
    //     map: this.mapM
    //   }));
    // });
    this.maker();
    this.mapM.on("zoomend", () => {
      let zoom = this.mapM.getZoom();
      //关联点出现不监听
      this.getZoomData(zoom);
    });
  },
  methods: {
    changeProvince(item) {
      const rLoading = this.openLoading();
      areaDetailFangTing({ areaName: item })
        .then((res) => {
          if (res.code === 200) {
            this.activeProvince = item;
            this.activeProvinceDetail = res.data.areaInfo.varietiesList;
            let currentProvince = this.activeProvinceDetail
              .filter((item) => item.varieties === "苯供需")
            console.log(currentProvince);

            let colors = null;
            if (Number(currentProvince[0].sum) > 0) {
              colors = "#0E9B21";
            } else {
              colors = "#E474D8";
            }
            // 清除之前的高亮
            this.clearHighlight();
            // 根据区域名称获取对应的adcode数组
            const adcodes = this.areaAdcodeMap[item];
            if (!adcodes || adcodes.length === 0) {
              console.warn(`未找到区域 ${item} 对应的adcode`);
              return;
            }
            // 高亮对应区域
            this.highlightAreas(adcodes, colors);

          }
          rLoading.close();
        })
        .catch(() => {
          rLoading.close();
        });
    },

    // 清除高亮
    clearHighlight() {
      // 使用 DistrictExplorer 的方法清除所有绘制的区域
      this.districtExplorer.clearFeaturePolygons();
      this.highlightPolygons = [];

      // 重新绘制地图的基础颜色（保持原有的填充色和边框色）
      var adcode = 100000; //全国的区划编码
      const that = this;
      that.districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
        if (error) {
          console.error(error);
          return;
        }

        // 重新绘制地图基础颜色（保持原有的填充色和边框色）
        that.districtExplorer.renderSubFeatures(
          areaNode,
          function (feature, i) {
            return {
              cursor: "default",
              bubble: true,
              strokeColor: "#5591ab", // 保持原线颜色
              strokeOpacity: 1, // 线透明度
              strokeWeight: 1, // 保持原线宽
              fillColor: "#9bd196", // 保持原填充色
              fillOpacity: 0.35, // 保持原填充透明度
            };
          }
        );
        // 更新地图视野
        // that.mapM.setFitView(that.districtExplorer.getAllFeaturePolygons());
      });
    },

    // 高亮区域
    highlightAreas(adcodes, colors) {
      const that = this;

      // 创建高亮多边形数组
      that.highlightPolygons = [];

      // 遍历adcode数组，加载并高亮每个区域
      adcodes.forEach((adcode) => {
        that.districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(`加载区域 ${adcode} 失败:`, error);
            return;
          }

          // 绘制区域多边形并添加高亮效果
          that.districtExplorer.renderSubFeatures(
            areaNode,
            function (feature, i) {
              return {
                cursor: "pointer",
                bubble: true,
                strokeColor: colors, // 高亮边框颜色
                strokeOpacity: 1, // 高亮边框透明度
                strokeWeight: 1.5, // 高亮边框宽度
                fillColor: colors, // 高亮填充颜色
                fillOpacity: 0.8, // 高亮填充透明度
              };
            }
          );
          // 获取所有绘制的多边形并保存到高亮数组中
          that.highlightPolygons =
            that.districtExplorer.getAllFeaturePolygons();

          // 更新地图视野以适合高亮区域
          // that.mapM.setFitView(that.highlightPolygons);
        });
      });
    },
    // 重置半径
    resetRadius() {
      this.radius = null;
    },
    // 确认半径
    confirmRadius() {
      if (this.radius && this.radius > 0 && this.selectedPosition) {
        // 清除已存在的圆
        this.mapM.remove(this.circles);
        this.circles = [];

        // 转换半径为米
        const radiusInMeters = this.radius * 1000;

        // 创建圆
        const circle = new AMap.Circle({
          center: this.selectedPosition,
          radius: radiusInMeters,
          borderWeight: 2,
          strokeColor: "#3072f7",
          strokeOpacity: 0.8,
          strokeDasharray: 0,
          fillColor: "#3072f7",
          fillOpacity: 0.35,
        });

        // 添加到地图
        circle.setMap(this.mapM);

        // 保存到 circles 数组，方便后续清除
        this.circles.push(circle);
        this.getAllCompanys();

        this.radiusDialogVisible = false;
      } else if (!this.selectedPosition) {
        this.$message.warning("请先选择一个标记点");
      } else {
        this.$message.warning("请输入有效的距离值");
      }
    },

    /**
     * 获取下拉框
     */
    getDistinctVarieties() {
      methanolMapSelect().then((res) => {
        // console.log(res);
        this.listOfOption = res["data"];
      });
    },

    /**
     * 切换企业和汇总
     * @param num
     */
    changeButton(num) {
      this.showCompany = num;
      this.getAllCompanys();
    },
    /**
     * 确认选择下拉框
     */
    changeSelect() {
      this.getAllCompanys();
    },
    /**
     * 获取地图数据
     */
    maker() {
      let that = this;
      AMapUI.loadUI(["geo/DistrictExplorer"], function (DistrictExplorer) {
        initPage(DistrictExplorer);
      });

      function initPage(DistrictExplorer) {
        //创建一个实例
        that.districtExplorer = new DistrictExplorer({
          map: that.mapM, //关联的地图实例
        });

        var adcode = 100000; //全国的区划编码

        that.districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }

          //绘制载入的区划节点
          renderAreaNode(that.districtExplorer, areaNode);
        });
      }

      function renderAreaNode(districtExplorer, areaNode) {
        //清除已有的绘制内容
        districtExplorer.clearFeaturePolygons();

        //just some colors
        var colors = [
          "#3366cc",
          "#dc3912",
          "#ff9900",
          "#109618",
          "#990099",
          "#0099c6",
          "#dd4477",
          "#66aa00",
        ];

        //绘制子级区划
        districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
          var fillColor = colors[i % colors.length];
          var strokeColor = colors[colors.length - 1 - (i % colors.length)];

          return {
            cursor: "default",
            bubble: true,
            strokeColor: "#5591ab", //线颜色
            strokeOpacity: 1, //线透明度
            strokeWeight: 1, //线宽
            fillColor: "#9bd196", //填充色
            fillOpacity: 0.35, //填充透明度
          };
        });

        //绘制父级区划，仅用黑色描边
        // districtExplorer.renderParentFeature(areaNode, {
        //   cursor: "default",
        //   bubble: true,
        //   strokeColor: "black", //线颜色
        //   fillColor: null,
        //   strokeWeight: 3, //线宽
        // });

        //更新地图视野以适合区划面
        that.mapM.setFitView(districtExplorer.getAllFeaturePolygons());
      }

      this.getAllCompanys();
    },
    /**
     * 获取地图数据
     */
    getAllCompanys() {
      const rLoading = this.openLoading();
      if (this.showCompany === 3) {
        this.detailLlag = false;
        this.clearPoint();
        this.mapM.remove(this.circles);
        this.circles = [];
        // 加载地区数据
        areaDetailFangTing()
          .then((res) => {
            if (res.code === 200) {
              this.activeProvince = "全部地区";
              this.activeProvinceDetail = res.data.areaInfo.varietiesList;
              this.allProvinceDetail = res.data.areaInfo.varietiesList;
            }
            rLoading.close();
          })
          .catch(() => {
            rLoading.close();
          });
        // 加载苯地图数据
        mapBen()
          .then(res => {
            if (res.code === 200) {
              this.allCompnays = res["data"];
              this.getZoomData(this.zoomNow);
            }
          })
      } else {
        this.activeProvinceDetail = [];
        this.allProvinceDetail = [];
        this.districtExplorer && this.clearHighlight();

        let type = "";
        if (this.selectTypes.length > 0) {
          this.showAll = false;
          this.selectOptions = JSON.parse(JSON.stringify(this.selectTypes));
          type = this.selectTypes.join(",");
        } else {
          this.showAll = true;
          this.selectOptions = [];
        }
        oilBenzeneMapDetail({
          type: type,
          showCompany: this.showCompany,
          mapFlag: 2,
        })
          .then((suc) => {
            if (suc["data"]) {
              this.allCompnays = suc["data"];
              this.getZoomData(this.zoomNow);
              // this.maker();
            } else {
              this.$message.info("暂无数据");
            }
            rLoading.close();
          })
          .catch((err) => {
            rLoading.close();
          });
      }
    },
    //根据级别显示数据
    getZoomData(zoom) {
      this.zoomNow = zoom;
      if (this.polylines.length === 0) {
        if (this.showCompany === 1) {
          if (this.allCompnays) {
            this.companys = this.allCompnays[`companysInfo`]; //
            this.setMap();
          }
        } else if (this.showCompany === 2) {
          if (_.includes([0, 1, 2, 3, 4, 5, 6], zoom)) {
            // console.log('[0,1, 2,3,4,5,6] :' + zoom)
            this.provinceCompanys = this.allCompnays[`provincesInfo`];
            this.setNoDetailMap("province");
          } else if (_.includes([7, 8], zoom)) {
            // console.log('[7, 8] :' + zoom)
            this.provinceCompanys = this.allCompnays[`citysInfo`];
            this.setNoDetailMap("city");
          } else if (zoom > 8) {
            // console.log('> 8 :' + zoom)
            this.companys = this.allCompnays[`companysInfo`]; //
            // this.cokeCompanys=this.allCompnays[`companysInfo`][0].coke//焦化
            // this.steelCompanys=this.allCompnays[`companysInfo`][2].steel
            this.setMap();
          }
        } else {
          if (_.includes([0, 1, 2, 3, 4, 5, 6], zoom)) {
            // console.log('[0,1, 2,3,4,5,6] :' + zoom)
            this.provinceCompanys = this.allCompnays[`provincesInfo`];
            this.setNoDetailMap("province");
          } else {
            this.provinceCompanys = this.allCompnays[`citysInfo`];
            this.setNoDetailMap("city");
          }
        }
      }
    },
    /**
     * 省市汇总
     * @param str
     */
    setNoDetailMap(str) {
      this.clearPoint();
      let marker1;

      let icon1 = new AMap.Icon({
        image: require("@/assets/map/redXing.png"),
        size: new AMap.Size(24, 24),
      });
      marker1 = new AMap.Marker({
        icon: icon1,
        position: this.oneB[0].center.split(","),
        offset: new AMap.Pixel(-12, -12),
        // zIndex: 101,
        title: this.oneB[0].name,
        map: this.mapM,
      });
      this.markers.push(marker1);
      //tbule  省 市
      if (this.provinceCompanys) {
        for (var i = 0; i < this.provinceCompanys.length; i++) {
          let company = this.provinceCompanys[i];
          // 根据company.varietiesList 筛选出 varieties === "苯供需"的数据对象
          if (company.lat != null && company.lng != null) {
            this.clickYuanHidden(
              company.lng,
              company.lat,
              company[`${str}`],
              company[`capacity`],
              company["varietiesList"]
            );
          }
        }
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    /**
     * 设置地图
     */
    setMap() {
      this.clearPoint();
      let marker1 = null;

      let icon1 = new AMap.Icon({
        image: require("@/assets/map/redXing.png"),
        size: new AMap.Size(24, 24),
      });
      marker1 = new AMap.Marker({
        icon: icon1,
        position: this.oneB[0].center.split(","),
        offset: new AMap.Pixel(-12, -12),
        // zIndex: 101,
        title: this.oneB[0].name,
        map: this.mapM,
      });
      this.markers.push(marker1);
      //天蓝 钢厂
      for (var i = 0; i < this.companys.length; i++) {
        let company = this.companys[i];
        if (company.lat != null && company.lng != null) {
          let marker;
          let images = require("@/assets/map/mark_bs.png");

          //苯加氢\石油苯\苯乙烯\PS\EPS\ABS\己内酰胺\己二酸
          if (company.varieties === "苯加氢") {
            images = require("@/assets/map/mark_1.png");
          } else if (company.varieties === "石油苯") {
            images = require("@/assets/map/mark_2.png");
          } else if (company.varieties === "苯乙烯") {
            images = require("@/assets/map/mark_3.png");
          } else if (company.varieties === "PS") {
            images = require("@/assets/map/mark_4.png");
          } else if (company.varieties === "EPS") {
            images = require("@/assets/map/mark_5.png");
          } else if (company.varieties === "ABS") {
            images = require("@/assets/map/mark_6.png");
          } else if (company.varieties === "己内酰胺") {
            images = require("@/assets/map/mark_7.png");
          } else if (company.varieties === "己二酸") {
            images = require("@/assets/map/mark_8.png");
          } else if (company.varieties === "苯酚") {
            images = require("@/assets/map/mark_bFen.png");
          } else if (company.varieties === "苯胺") {
            images = require("@/assets/map/mark_bAn.png");
          }

          let iconM = new AMap.Icon({
            image: images,
          });
          marker = new AMap.Marker({
            icon: iconM,
            position: [company.lng, company.lat],
            title: company.companyName,
            map: this.mapM,
          });
          marker.on("click", (e) => {
            // console.log(company);
            // 清除之前的圆圈
            this.mapM.remove(this.circles);
            this.circles = [];
            // 保存选中标记的位置
            this.selectedPosition = [company.lng, company.lat];
            // 打开半径输入弹框
            this.radiusDialogVisible = true;

            this.mapM.remove(this.polylines);
            this.polylines = [];
            $(".detailDetail").html("");
            this.onePosition = [company.lng, company.lat];
            this.oneCompanyCode = company.companyCode;
            this.varieties = company.varieties;
            this.oneType = "4";
            //this.getCompanyOne(this.onePosition)
            this.getOneDetail(this.onePosition);
          });
          this.markers.push(marker);
        }
      }
      if (this.markertNow.length > 0) {
        this.markNowAdd(this.markertNowPOsition);
      }
      this.mapM.setZoomAndCenter(this.zoomNow);

      //this.mapM.setFitView();//地图自适应
    },
    clickYuanHidden(lng, lat, str, capacity, varietiesList) {
      let iconM = new AMap.Icon({
        image: require("@/assets/map/mark_zi.png"),
        size: new AMap.Size(24, 24),
      });
      let marker = new AMap.Marker({
        icon: iconM,
        position: [lng, lat],
        title: str,
        map: this.mapM,
      });
      let markerContent = document.createElement("div");
      markerContent.className = "markerDiv";

      if (this.showCompany === 3) {
        let benNeed = varietiesList.find(
          (item) => item.varieties === "苯供需"
        );
        // 流出是绿色，流入是红色
        // 正数是流出，负数是流入
        if (Number(benNeed.sum) > 0) {
          markerContent.style.backgroundColor = "#0E9B21";
        } else {
          markerContent.style.backgroundColor = "#E474D8";
        }
      } else {
        markerContent.style.backgroundColor = "#3072f7";
      }
      markerContent.style.borderRadius = "50%";
      markerContent.style.height = "85px";
      markerContent.style.width = "85px";
      markerContent.style.wordBreak = "break-all";
      markerContent.style.textAlign = "center";
      markerContent.style.padding = "5px";
      markerContent.style.boxShadow = "#5d5d5d 0px 0px 4px 0px";
      markerContent.style.display = "table";
      let tempstr = "";
      varietiesList.map((item) => {
        tempstr += `${item["varieties"]} : ${item["sum"] ? item["sum"] : 0}   `;
      });
      markerContent.title = tempstr;

      let testContent = document.createElement("div");
      testContent.className = "markerDivText";
      testContent.style.wordBreak = "break-all";
      testContent.style.textAlign = "center";
      testContent.style.display = "table-cell";
      testContent.style.verticalAlign = "middle";
      markerContent.appendChild(testContent);

      // 点标记中的文本
      var markerSpan = document.createElement("p");
      markerSpan.className = "marker";
      markerSpan.innerHTML = str;
      markerSpan.style.position = "relative";
      markerSpan.style.color = "#ffffff";
      markerSpan.style.padding = "9px 10px 0 10px";
      markerSpan.style.whiteSpace = "break-word";
      markerSpan.style.fontSize = "12px";
      markerSpan.style.fontWeight = "600";
      // markerSpan.style.display = 'inline-block';
      markerSpan.style.lineHeight = "12px";
      testContent.appendChild(markerSpan);
      if (this.showCompany === 3) {
        let benNeed = varietiesList.find(
          (item) => item.varieties === "苯供需"
        );
        let markerSpan2 = document.createElement("span");
        markerSpan2.className = "marker";
        markerSpan2.innerHTML = `${benNeed.varieties}:${benNeed.sum ? benNeed.sum : 0
          }`;
        markerSpan2.style.position = "relative";
        markerSpan2.style.color = "#ffffff";
        markerSpan2.style.padding = "2px 5px 0 5px";
        markerSpan2.style.fontSize = "12px";
        markerSpan2.style.display = "inline-block";
        testContent.appendChild(markerSpan2);
        marker.setContent(markerContent); //更新点标记内容
      } else {
        for (let i = 0; i < (varietiesList.length < 2 ? 1 : 2); i++) {
          let markerSpan2 = document.createElement("span");
          markerSpan2.className = "marker";
          markerSpan2.innerHTML = `${varietiesList[i]["varieties"]}:${varietiesList[i]["sum"] ? varietiesList[i]["sum"] : 0
            }`;
          markerSpan2.style.position = "relative";
          markerSpan2.style.color = "#ffffff";
          markerSpan2.style.padding = "2px 5px 0 5px";
          markerSpan2.style.fontSize = "12px";
          markerSpan2.style.display = "inline-block";
          testContent.appendChild(markerSpan2);
          marker.setContent(markerContent); //更新点标记内容
        }
      }

      marker.on("click", (e) => {
        if (this.showCompany === 3) {
          // console.log(varietiesList);
          this.activeProvince = str;
          this.activeProvinceDetail = varietiesList;
        }

        // marker = null;
        // this.mapM.remove([lng, lat]);
        // this.clickYuanHidden(lng, lat, str, capacity, varietiesList);
      });
      this.markers.push(marker);
    },
    /**
     * 添加点
     */
    markNowAdd(position) {
      let iconM = new AMap.Icon({
        image: require("@/assets/map/mark_r.png"),
      });
      let marker = new AMap.Marker({
        icon: iconM,
        position: position,
        map: this.mapM,
        zIndex: 100, // 设置一个较高的 zIndex 确保标记显示
      });
      // 为新添加的标记也添加点击事件，允许重新打开半径弹框
      marker.on("click", (e) => {
        // // 清除之前的圆圈
        // this.mapM.remove(this.circles);
        // this.circles = [];
        this.selectedPosition = position;
        this.radius = null;
        this.radiusDialogVisible = true;
      });
      this.markertNowPOsition = position;
      this.markertNow.push(marker);
    },
    /**
     * 清除点
     */
    clearPoint() {
      if (this.zoomNow < 8) {
        this.mapM.remove(this.markertNow);
        this.markertNow = [];
        this.markertNowPOsition = null;
      }
      this.mapM.remove(this.markers);
      this.mapM.remove(this.polylines);
      this.polylines = [];
      this.markers = [];
    },

    //移除当前选中的企业坐标
    removeNowMarket() {
      this.mapM.remove(this.markertNow);
      this.markertNow = [];
      this.markertNowPOsition = null;
    },
    getOneDetail(position) {
      //标记当前点
      this.removeNowMarket();

      this.markNowAdd(position);

      const rLoading = this.openLoading();
      let param = {
        user: this.LOGIN_USER_ID, //'admin',//
        companyCode: this.oneCompanyCode,
        varieties: this.varieties,
        type: this.oneType,
      };
      companyDetailFangTing(param)
        .then((suc) => {
          if (suc["data"] && suc["data"].length > 0 && suc["data"][1] != null) {
            // console.log(suc["data"]);
            this.canShowDetailDetail = suc["data"][0].show;
            for (const positionKey in suc["data"][1]) {
              suc["data"][1][positionKey] =
                suc["data"][1][positionKey] == null
                  ? "暂无数据"
                  : suc["data"][1][positionKey];
            }

            _.forEach(suc["data"][2], (item, index) => {
              for (const positionKey in item) {
                item[positionKey] =
                  item[positionKey] == null || ""
                    ? "暂无数据"
                    : item[positionKey];
              }
            });
            _.forEach(suc["data"][3], (item, index) => {
              for (const positionKey in item) {
                item[positionKey] =
                  item[positionKey] == null || ""
                    ? "暂无数据"
                    : item[positionKey];
              }
            });
            _.forEach(suc["data"][4], (item, index) => {
              for (const positionKey in item) {
                item[positionKey] =
                  item[positionKey] == null || ""
                    ? "暂无数据"
                    : item[positionKey];
              }
            });
            this.verneCompanyDetail = suc["data"][1];
            this.verneCompanyDetail.deviceInfos = suc["data"][2];
            this.verneCompanyDetail.materialSupplies = suc["data"][3];
            this.verneCompanyDetail.productFlows = suc["data"][4];
            this.createInfo(position);
          } else {
            this.$message.info("暂无数据");
          }
          rLoading.close();
        })
        .catch(() => {
          rLoading.close();
        });
    },
    //构建自定义信息窗体
    createInfo(position) {
      this.detailLlag = true;
    },
    closeDio() {
      this.detailLlag = false;
    },
  },
};
</script>

<style scoped lang="less">
.detail {
  position: absolute;
  top: 20%;
  right: 44px;
  width: 300px;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  padding: 50px 30px;

  img {
    position: absolute;
    top: 17px;
    right: 21px;
    cursor: pointer;
  }

  p {
    font-size: 16px;
  }

  .top {
    margin-top: 10px;
    border-bottom: none !important;
  }

  .top,
  .bom {
    border: 1px solid #f4e4e4;
    width: 305px;
    display: flex;

    span {
      display: block;
      padding-left: 20px;
      width: 100px;
      min-height: 44px;
      background: #fdf3f3;
      display: flex;
      align-items: center;
    }

    em {
      flex: 1;
      display: block;
      padding: 0 6px 0 20px;
      line-height: 30px;
      background: #ffffff;
      font-style: normal;
      display: flex;
      align-items: center;
    }
  }
}

.legend {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  color: #000;
  padding: 10px 30px 10px 20px;

  .legend_title {
    font-size: 16px;
    margin-bottom: 6px;
  }

  .legend_li {
    display: flex;
    align-items: center;
    height: 30px;

    .square {
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }

    .txt {
      line-height: 30px;
    }
  }
}

.legendProvince {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  color: #000;

  .legend_title {
    padding: 10px 30px 10px 20px;
    font-size: 16px;
    margin-bottom: 6px;
    border-bottom: 1px solid #ebe1e1;
  }

  .legend_li {
    padding: 0 20px 0 20px;
    display: flex;
    align-items: center;
    height: 35px;
    cursor: pointer;
    justify-content: center;
    border-bottom: 1px solid #f5f5f5;

    .square {
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }

    .txt {
      line-height: 35px;
    }
  }

  .legend_li:hover {
    background: #387bed;
    color: #fff;
  }
}

.activeTab {
  background: #387bed;
  color: #fff;
}

.legend_li_all {
  padding: 0 20px 0 20px;
  display: flex;
  align-items: center;
  height: 35px;
  // justify-content: center;
  border-top: 1px solid #ebe1e1;
  font-weight: bold;
}
</style>
